import React, { useState } from "react";
import "./styles/referral.css";
import Footer from "./Footer";
import Swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css'; // ✅ Use CSS instead of SCSS
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import wabes from './styles//images/download.svg';
import axios from "axios";

function Referal() {
    const [formData, setFormData] = useState({
        to_name: "Unique Home Care Inc",
        referr_name: "",
        from_name: "",
        referr_lastname: "",
        referr_phone: "",
        referr_email: "",
        client_name: "",
        client_lastname: "",
        dob: "",
        ss_no: "",
        ma_number: "",
        client_address: "",
        street_address: "",
        client_city: "",
        client_zip: "",
        client_state: "",
        service: "homecare",
        message: "",
    });
    const [isSubmitting, setIsSubmitting] = useState(false);
    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };
     const SendEmail = async(e) => {
            e.preventDefault();
        setIsSubmitting(true);
            // Manually update the form's `from_name` before sending
            const form = e.target;
            const formData = new FormData(form);
            formData.set("from_name", `${formData.get("referrer_first_name")} ${formData.get("referrer_last_name")}`);
        
            try {
                // Replace the URL with your backend API endpoint
                const response = await axios.post("https://samahomecare.com/api/refferal.php", formData, {
                  headers: {
                    "Content-Type": "application/json",
                  },
                });
                Swal.fire({
                  title: "Form submitted Successfully!",
                  icon: "success",
                }).then(()=>{
                    setFormData({
                        to_name: "Unique Home Care Inc",
                        referr_name: "",
                        from_name: "",
                        referr_lastname: "",
                        referr_phone: "",
                        referr_email: "",
                        client_name: "",
                        client_lastname: "",
                        dob: "",
                        ss_no: "",
                        ma_number: "",
                        client_address: "",
                        street_address: "",
                        client_city: "",
                        client_zip: "",
                        client_state: "",
                        service: "homecare",
                        message: "",
                    });// Reset form state
                    form.reset();
                setIsSubmitting(false);
                })
              } catch (err) {
                Swal.fire({
                  title: "Failed to send referral",
                  icon: "error",
                });
                console.error("FAILED...", err);
              }
            };   
   
    
    return (
        <>
             <section id="about1" className="about">
                           <div className="wrap"></div>
                               <div className="container">
                                   <div className="row">
                                       <div className="col-lg-12 col-md-12 col-sm-12 pb-5" id="about-col1">
                                       
                                           <h1 className="heading">  Refer a <span className="hero-highlight">Friend</span>  <br /> Make a  <span className="hero-highlight">Difference</span></h1>
                                           <p className="supporting">
                                           Help your friends and family receive the best care. Fill out the referral form and let us connect them with quality services.
                                               </p>
                                       </div>
                                   </div>
                               </div>
                                 <img src={wabes} alt="Waves" id="waves1" />
                           </section>
            <section id="referral-Why" >
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 col-md-12 col-sm-12" id="referral-text" data-aos="fade-up">
                            <h1 data-aos="fade-up">
                                Why <strong style={{color:'#00a9f4',fontSize:'60px'}}> Make</strong> A  Referral
                            </h1>
                            <p>
                                When you refer a friend, you're not just sharing a service—you’re making a real difference in someone's life. Your referral helps connect those in need with compassionate, high-quality care, ensuring they receive the support they deserve.                    </p>
                            <ul>
                                <li data-aos="slide-up"><i className="fas fa-check-circle" style={{ marginRight: '10px' }} ></i>Help us make a bigger impact</li>
                                <li data-aos="slide-up"><i className="fas fa-check-circle" style={{ marginRight: '10px' }} ></i>Change lives</li>
                                <li data-aos="slide-up"><i className="fas fa-check-circle" style={{ marginRight: '10px' }} ></i>Empower a loved one with trusted care</li>
                                <li data-aos="slide-up"><i className="fas fa-check-circle" style={{ marginRight: '10px' }} ></i>Help families find the support they need</li>
                                <li data-aos="slide-up"><i className="fas fa-check-circle" style={{ marginRight: '10px' }} ></i><a href="#referral-How">Go to the Referral Form</a></li>
                            </ul>
                            <p>
                                Your simple act of referring can change lives—because everyone deserves care they can count on.

                                Refer today and make a difference!
                            </p>
                        </div>
                    </div>
                </div>
            </section>
            <section id="referral-How">
                <div className="container">
                    <div className="row" data-aos="fade-up">
                        <div className="col-lg-12 col-md-12 col-sm-12" id="Referral-Form">
                            <div className="Header-text">
                                <h1>Make a Referral for PCA/CFSS!</h1>
                            </div>

                            <form onSubmit={SendEmail}>
                                <h3>Person Referring Information</h3>
                                <div className="Personal-info">
                                    <div className="upper">
                                        <div className="left-info">
                                            <label>First Name:</label><br />
                                            <input type="text" name="referrer_first_name" onChange={handleChange} required placeholder="First Name" />
                                        </div>
                                        <div className="right-info">
                                            <label>Last Name:</label><br />
                                            <input type="text" name="referrer_last_name" onChange={handleChange} required placeholder="Last Name"/>
                                        </div>
                                    </div>
                                    <div className="lower">
                                        <div className="left-info">
                                            <label>Referrer's Phone Number:</label><br />
                                            <input type="text" name="referrer_phone" onChange={handleChange} required placeholder="Phone Number"/>
                                        </div>
                                        <div className="right-info">
                                            <label>Referrer's Email:</label><br />
                                            <input type="email" name="referrer_email" onChange={handleChange} required placeholder="Email" />
                                        </div>
                                    </div>
                                </div>

                                <h3>Client's Information</h3>
                                <div className="Client-info">
                                    <div className="upper">
                                        <div className="left-info">
                                            <label>First Name:</label><br />
                                            <input type="text" name="client_first_name" onChange={handleChange} required placeholder="First Name"/>
                                        </div>
                                        <div className="right-info">
                                            <label>Last Name:</label><br />
                                            <input type="text" name="client_last_name" onChange={handleChange} required placeholder="Last Name"/>
                                        </div>
                                    </div>
                                    <div className="lower">
                                        <div className="left-info">
                                            <label>Date of Birth:</label><br />
                                            <input type="date" name="client_dob" onChange={handleChange} required  />
                                        </div>
                                        <div className="right-info">
                                            <label>SS No #:</label><br />
                                            <input type="text" name="client_ssn" onChange={handleChange} required placeholder="SS No #"/>
                                        </div>
                                    </div>
                                    <div className="lower-lower">
                                        <label>MA Number:</label><br />
                                        <input type="text" name="client_ma_number" onChange={handleChange} required placeholder="MA Number"/>
                                    </div>
                                </div>

                                <div className="client-address">
                                    <label>Address</label><br />
                                    <input type="text" name="client_address" onChange={handleChange} required  placeholder="Address"/>
                                    <label>Street Address</label><br />
                                    <input type="text" name="street_address" onChange={handleChange} required  placeholder="Street Address"/>
                                    <div className="dual">
                                        <div className="upper">
                                            <div className="right-info">
                                                <label>City</label><br />
                                                <input type="text" name="client_city" onChange={handleChange} required  placeholder="City"/>
                                            </div>
                                            <div className="left-info">
                                                <label>Zip Code</label><br />
                                                <input type="text" name="client_zip" onChange={handleChange} required placeholder="Zip Code"/>
                                            </div>
                                        </div>
                                        <label>State</label><br />
                                        <input type="text" name="client_state" onChange={handleChange} required placeholder="State" />
                                    </div>
                                </div>

                                <div className="end-form">
                                    <div className="Services">
                                        <label htmlFor="services">Choose a Service:</label><br />
                                        <select name="service" onChange={handleChange} required>
                                            <option value="homecare">Select a Service</option>
                                            <option value="cfss">CFSS</option>
                                            <option value="pca">PCA</option>
                                        </select>
                                    </div>

                                    <div className="Quick-note">
                                        <label>Quick note:</label><br />
                                        <textarea name="message" onChange={handleChange} placeholder="Quick Note"></textarea>
                                    </div>

                                    <div className="submit-btn">
                                        <button type="submit" className="nav0cta1">Submit</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </section>
            <ToastContainer />
            <Footer />
        </>
    );
}

export default Referal;